module.exports = __webpack_public_path__ + "img/emptyStar.3dc063ee.svg";